import type { To } from 'react-router'

type RelativeRoutingType = 'route' | 'path'

export type HazardDetailLocationState = {
  hazardDetailBack?: {
    to: To
    relative?: RelativeRoutingType
  }
}

export function hazardDetailLinkStateFromSafetyFunction(
  safetyFunctionId: string
): HazardDetailLocationState {
  return {
    hazardDetailBack: {
      to: `../safety-functions/${safetyFunctionId}`,
      relative: 'route',
    },
  }
}

export function hasCustomHazardDetailBack(state: unknown): boolean {
  if (state != null && typeof state === 'object') {
    const back = (state as HazardDetailLocationState).hazardDetailBack
    return back != null && back.to != null
  }
  return false
}

export function resolveHazardDetailBack(state: unknown): {
  to: To
  relative?: RelativeRoutingType
} {
  if (state != null && typeof state === 'object') {
    const back = (state as HazardDetailLocationState).hazardDetailBack
    if (back != null && typeof back === 'object' && back.to != null) {
      return back
    }
  }
  return { to: '..', relative: 'path' }
}
